// Module
var code = "<script id=\"wcc-components-wcc-loader\" type=\"text/template\">\r\n    <img class=\"loader inline\" data-bind=\"attr: { 'src': images.loader }\"/>\r\n</script>";
// Exports
module.exports = code;